var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70703 6.29036H10.2904V7.8737H8.70703V6.29036ZM8.70703 9.45703H10.2904V14.207H8.70703V9.45703ZM9.4987 2.33203C5.1287 2.33203 1.58203 5.8787 1.58203 10.2487C1.58203 14.6187 5.1287 18.1654 9.4987 18.1654C13.8687 18.1654 17.4154 14.6187 17.4154 10.2487C17.4154 5.8787 13.8687 2.33203 9.4987 2.33203ZM9.4987 16.582C6.00745 16.582 3.16536 13.7399 3.16536 10.2487C3.16536 6.75745 6.00745 3.91536 9.4987 3.91536C12.9899 3.91536 15.832 6.75745 15.832 10.2487C15.832 13.7399 12.9899 16.582 9.4987 16.582Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.68fd4daf2615ef29b156a84a1f5dfd2c.svg";
export { ForwardRef as ReactComponent };